import { SET_THEME_OPTION } from '@rentivo/gatsby-core/src/theme/constants';

export const setThemeOption = (key, value) => {
  return {
    type: SET_THEME_OPTION,
    key,
    value
  };
};
